export const BASE_URL 									= 				process.env.LOCAL_FACADE_SERVER_FULL_ADDRESS_ADMIN
export const CLIENT_PORTAL_URL 							= 				process.env.cpLink
export const IB_PORTAL_URL 							    = 				process.env.ibLink
export const EP_ADMIN_LOGIN 							= 				'/api/login'
export const EP_ADMIN_LOGOUT 							= 				'/signout'

export const EP_GET_CITIES_LIST							=				'/admin/get/city/list' 

export const EP_GET_ADMIN_LIST 			    			= 				'/admin/get/admins/list'
export const EP_ADD_WEBINAR 			    			= 				'/add/webinar/blog'
export const EP_GET_CLIENT_DATA 			    		= 				'/api/get/client/data'


export const EP_GET_IB_LIST 			    			= 				'/admin/get/ib/list'
export const EP_GET_IB_CHANGE_LIST 			    		= 				'/admin/get/ib-change/list'
export const EP_GET_IB_VIEW 			    			= 				'/admin/get/ib/details'
export const EP_GET_IB_TASK_LIST						=				'/admin/ib/task/list'
export const EP_IB_ADD_TASK 							=				'/admin/ib/task/create'
export const EP_IB_TASK_UPDATE_STATUS 					=				'/admin/ib/task/status/update'
export const EP_DOWNLOAD_IB_DEPOSIT_FILE				=				''
export const EP_GET_IB_WITHDRAWAL_LIST					=				''
export const EP_GET_IB_LOGS_DETAIL 						=				''
export const EP_DOWNLOAD_IB_WITHDRAWAL_FILE				=				''
export const EP_GET_IB_DEPOSIT_LIST						=				''
export const EP_IB_VERIFY_ACCOUNT 						=				''
export const EP_IB_ADD_INTERNAL_NOTES 					=				''
export const EP_CREATE_IB_ACTIVITY						=				''
export const EP_UPDATE_IB_DETAIL 						= 				'/admin/update/ib'
export const EP_IB_DISABLE2FA 							= 				'/admin/disable/ib/twofa'
export const EP_IB_CLOSE_ACCOUNT 						= 				'/admin/ib/close'
export const EP_IB_SEND_MAIL 							= 				'/admin/ib/send/mail'
export const EP_IB_RESET_PASSWORD 						= 				'/admin/reset/ib/password'
export const EP_GET_IB_LOGS_LIST 						= 				'/admin/ib/logs'




export const EP_CREATE_TUT_COURSE						=				'/add/tut/course'
export const EP_GET_TUT_COURSE							=				'/get/tut/course'
export const EP_CREATE_TUT_CAT							=				'/add/tut/category'
export const EP_GET_TUT_CAT								=				'/get/tut/category'
export const EP_GET_TUTORIAL_LIST 			    		= 				'/get/tutorial'
export const EP_CREATE_TUTORIAL 			    		= 				'/add/tutorial'

export const EP_ADD_CATEGORY 			    			= 				'/add/category'
export const EP_ADD_POST 			    				= 				'/add/posts'
export const EP_GET_CATEGORY_LIST 			    		= 				'/get/category'
export const EP_GET_POST_LIST 			    			= 				'/get/posts'




export const EP_GET_DASHBOARD_DATA 			    		= 				'/get/dashboard/data'
export const EP_GET_DASHBOARD_OTHER_DATA 			    = 				'/get/dashboard/other/data'
export const EP_GET_TOTAL_CLIENT	    	    		= 				"/get/dashboard/totalclient"


export const EP_GET_NOTIFICATION_LIST 			    	= 				'/webapp/common/get/notification'
export const EP_GET_ADMIN_DETAIL 			    		= 				'/admin/get/admins/details'
export const EP_ADD_ADMIN 			    			    = 				'/admin/add/admins'
export const EP_UPDATE_ADMIN_DETAIL 			    	= 				'/admin/update/admin'

export const EP_EMAIL_SETTING_LIST 			    		= 				'/email/setting/list' 
export const EP_ADD_EMAIL_SETTING 			    		= 				'/add/update/email/setting'

export const EP_GET_CLIENT_REPORT 			    		= 				'/admin/get/user/reports'
export const EP_CLOSE_ACCOUNT 			    			= 				'/admin/user/close'
export const EP_CHANGE_ACCOUNT_TYPE				         = 				 '/admin/change/islamic/type'
export const EP_REQUEST_OTP 			    			= 				'/admin/temp/client/access'
export const EP_VERIFY_OTP 			    				= 				'/admin/temp/client/access'

export const EP_IB_REQUEST_OTP 			    			= 				'/admin/temp/ib/access'
export const EP_IB_VERIFY_OTP 			    				= 				'/admin/temp/ib/access'

export const EP_ALLOW_FOR_IPV							=				''
export const EP_GET_ALL_INTERNAL_NOTES 					=				'/admin/get/all/internal/notes'

export const EP_GET_MANAGE_GROUP_LIST 			    	= 				'/admin/group/list'
export const EP_ADD_EDIT_ADMIN_MANAGE_GROUP_DATA 		= 				'/admin/manage/group'

export const EP_GET_TASK_LIST 			    			= 				'/admin/task/list'
export const EP_ADD_TASK 								= 				'/admin/task/create'
export const EP_TASK_UPDATE_STATUS						=				'/admin/task/status/update'

export const EP_DEPOSIT_UPDATE_SUSPENSE 			    = 				'/admin/update/suspense/deposit'
export const EP_DEPOSIT_ASSIGN							=				'/admin/update/suspense/ticket/reason'
export const EP_GET_GROUP_ADMIN_NAME					=				'/get/group/admin/name'
export const EP_CREATE_ACTIVITY							=				'/admin/create/user/activity'
export const EP_GET_ACTIVITY							=				'/admin/get/user/activity'
export const EP_DISABLE2FA 			    				= 				'/admin/disable/user/twofa'

export const EP_SEND_MAIL 			    				= 				'/admin/send/mail'

export const EP_DOWNLOAD_FILES 			    			= 				'/get/checked/withdrawals/csv'
export const EP_GET_USER_LIST 			    			= 				'/admin/get/user/list'
export const EP_GET_LOGS_LIST 			    			= 				'/admin/user/logs'
export const EP_GET_LOGS_VIEW 			    			= 				''
export const EP_GET_LOGS_DETAIL 			    		= 				'/admin/user/log/details'
export const EP_GET_USER_VIEW 			    			= 				'/admin/get/user/details'
export const EP_UPDATE_CLIENT_DETAIL					=				'/admin/update/user'
export const EP_RESET_PASSWORD 			    			= 				'/admin/reset/user/password'
export const EP_USER_COUNT 			    				= 				'/admin/user/count'
export const EP_ADD_WITHDRAWAL 			    			= 				'/admin/withdrawal/request/otp' 
export const EP_WITHDRAWAL_METHODS 			    		= 				'/admin/get/withdrawal/methods' 
export const EP_ADD_TICKET 			    				= 				'/admin/ticket/request'
export const EP_USER_NOTIFICATIONS 			    		= 				''
export const EP_ADD_INTERNAL_NOTES						= 				'/admin/create/notes'
export const EP_GET_INTERNAL_NOTES 			    		= 				'/admin/get/internal/notes'
export const EP_VERIFY_ACCOUNT 			    			= 				''
export const EP_GET_RISK_METRIX 			    		= 				'/admin/get/risk/metrix'
export const EP_CREATE_TRADING_ACCOUNT					=				'/admin/create/account'
export const EP_SAVE_FIREBASE_TOKEN         			=				'/save/firebase/token'

export const EP_GET_TICKET_LIST 						= 				'/admin/list/ticket'
export const EP_TICKET_TRANSFER 						= 				'/admin/ticket/transfer'
export const EP_ADD_WITHDRAWAL_TRANSACTION_ID 			= 				'/admin/update/withdrawal/transaction/id'
export const EP_GET_TICKET_VIEW 						= 				'/admin/ticket/details'
export const EP_TICKET_REASON_LIST 						= 				'/admin/get/ticket/reasons'
export const EP_TICKET_REPLY							=				'/admin/create/ticket/thread'
export const EP_TICKET_APPROVE							=				'/admin/ticket/approve'
export const EP_TICKET_APPROVE_USER						=				'/admin/user/approve'
export const EP_CLOSE_TICKET							=				'/admin/change/ticket/status'
export const EP_TICKET_DOC_APPROVE_REJECT				=				'/admin/ticket/doc/approve'

export const EP_CREATE_DEPOSIT 							= 				'/admin/add/deposit/detail'
export const EP_GET_DEPOSIT_LIST 						= 				'/admin/get/deposit/list'
export const EP_GET_DEPOSIT_VIEW 						= 				'/admin/get/deposit/details'
export const EP_EDIT_DEPOSIT_DETAILS 					= 				'/admin/update/deposit/transaction/status'
export const EP_GET_DEPOSIT_TRANSACTION_STATUS 			= 				'/admin/get/transaction/status'
export const EP_DEPOSIT_UPLOAD 							= 				'/deposit/upload'
export const EP_DEPOSIT_NOTES_UPDATE 					= 				'/admin/deposit/notes/update'
export const EP_GET_DEPOSIT_TRANSACTION_LIST 			= 				'/admin/get/deposit/transaction'
export const EP_UPDATE_DEPOSIT_TRANSACTION_ID 			= 				'/admin/change/deposit/transaction/id'

export const EP_GET_BONUS_LIST 							= 				'/admin/get/bonus/list'
export const EP_GET_BONUS_VIEW 							= 				'/admin/get/bonus/details'

export const EP_GET_CLIENT_IB_LIST 						= 				'/admin/get/bonus/list'

export const EP_GET_WITHDRAWAL_LIST 					= 				'/admin/get/withdrawal/list'
export const EP_GET_WITHDRAWAL_LIST_MAKER 				= 				'/admin/get/withdrawal/list/maker'
export const EP_GET_WITHDRAWAL_VIEW 	    			= 				'/admin/get/withdrawal/details'
export const EP_EDIT_WITHDRAWAL_DETAILS 				= 				'/admin/update/withdrawal/details'
export const EP_GET_ACCOUNT_DETAIL 			    		= 				'/admin/get/getmargininfoex' 

export const EP_GET_TRADING_LIST 						= 				'/admin/get/trading/list'
export const EP_GET_TRADING_VIEW 						= 				'/admin/get/trading/details'
export const EP_EDIT_TRADING_DETAILS 					= 				'/admin/update/trading/details'
export const EP_DOWNLOAD_TRADING_FILE 					= 				'/admin/get/trading/report'
export const EP_CHANGE_LEVERAGE 						= 				'/admin/update/account'


export const EP_GET_COUNTRIES_LIST						=				'/admin/get/country/list'

export const EP_CREATE_CATEGORY 			    		= 				'/api/blog/add/edit/categories'
export const EP_CREATE_ARTICLE 			    			= 				'/api/blog/add/edit/article'
export const EP_GET_ARTICLE_LIST 			    		= 				'/api/blog/article/list'
export const EP_GET_CAT_LIST 			    			= 				'/api/blog/category/list'
export const EP_GET_CAT_DETAIL 			    			= 				'/api/blog/category/details'
export const EP_GET_ARTICLE_DETAIL 			    		= 				'/api/blog/article/details'
export const EP_DELETE_ARTICLE 			    			= 				'/api/delete/article'
export const EP_DELETE_CATEGORY 			    		= 				'/api/delete/category'

export const EP_TICKET_APPROVE_MULTIPLE					=				'/admin/internal/deposit/approve'
export const EP_ESCALTE_TICKET							=				'/admin/update/maker/status'


export const EP_CREATE_COUPON 			    			= 				'/admin/coupon/create'
export const EP_GET_COUPON_LIST 			    		= 				'/admin/get/coupon/list'
export const EP_GET_PLAN_COUPON_LIST 			    	= 				'/admin/plan/coupon/list'

export const EP_SEND_WITH_DATA			    			= 				'/update/withdrawal/maker/list'
export const EP_GET_TICKET_REASON_LIST 					= 				'/admin/get/ticket/reasons'
export const EP_GET_TICKET_DETAIL 						= 				'/ticket/details'
export const EP_TICKET_RESEND_OTP 						= 				'/ticket/request/otp/resend'
export const EP_TICKET_REQUEST_OTP 						= 				'/ticket/request/otp'
export const EP_TICKET_CHECK_OTP 						= 				'/ticket/request'

export const EP_GET_NOTIFICATION_OLD_LIST 				= 				'/get/admin/notification'

export const EP_CHANGE_PASSWORD 						= 				'/change/password'

export const EP_DOWNLOAD_DEPOSIT_FILE					=				'/get/deposit/sheet'
export const EP_DOWNLOAD_WITHDRAWAL_FILE				=				'/get/withdrawal/sheet'

export const EP_GET_CHART_DATA							=				'/admin/user/chart/data'

export const EP_GET_RM_LIST 							=				'/admin/rm/list'

export const EP_REMOVE_USER 							=				''

export const EP_UPLOAD_DOCUMENT							= 				'/upload/trading/volume'

export const EP_GET_VPS_LIST							= 				'/admin/user/server/list'
export const EP_GET_SUBSCRIPTION_LIST					= 				'/admin/get/user/subscriptions'
export const EP_GET_SUBSCRIPTION_DETAIL					= 				'/admin/subscriptions/transactions/detail'
export const EP_USER_SUBSCRIPTION_END					= 				'/admin/user/subscription/end'
export const EP_USER_SUBSCRIPTION_UPDATE_ACCOUNT		= 				'/admin/update/tradingId'
export const EP_USER_OTHER_DETAILS						= 				'/get/user/summary'
export const EP_GET_LOYALITY_TRANSACTION_LIST			= 				'/admin/loyalty/transaction/list'
export const EP_GET_LOYALITY_CARD_LIST					= 				'/admin/loyalty/card/list'

export const EP_GET_BONUS_DETAIL						= 				'/admin/get/allowed/bonus'
export const EP_ADD_BONUS								= 				'/admin/bonus/otp'

export const EP_BULK_UPDATE_RM_ACCURACY					=				'/admin/rm/accuracy/update'

export const EP_GET_COMMISSION_REPORT_LIST				=				'/admin/get/commission/report/list'
export const EP_GET_COMMISSION_WITHDRAWAL_LIST			=				'/admin/get/commission/withdrawal/list'
export const EP_UPDATE_WITHDRAWAL_TRANSACTION_STATUS	=				'/admin/update/withdrawal/transaction/status'
export const EP_GET_COMMISSION_REPORT_DETAIL			=				'/admin/get/commission/report/detail'
export const EP_UPLOADS_LIST			                =				'/api/get/list/uploaded/reports'

export const DOWNLOAD_DOCS                              =               process.env.docsDownload + '/get/docs'
export const UPDATE_LOYALTY_POINTS                      =               '/traded/volume/points'
export const CLIENT_LEADS                               =               '/admin/get/leads'
export const EP_ADD_SUBSUM_USER_DATA                    =               '/admin/update/unapproved/user'

export const EP_ADMIN_ADD_DEPOSIT_METHODS                =               '/admin/add/deposit/methods'

export const EP_UPDATE_WITHDRAWAL_DETAILS               =               '/admin/update/withdrawal/request'

export const EP_LOCK_TRANSACTION 			    		= 				'/admin/lock/withdrawal/transaction'

export const EP_UPLOAD_RECEIPT		    		        = 				'/admin/upload/user/documents'
export const EP_UPLOAD_WITHDRAWAL_RECEIPT		    	= 				'/admin/upload/withdrawal/receipt'
export const EP_UPLOAD_DEPOSIT_RECEIPT		    		= 				'/admin/upload/deposit/receipt'
export const EP_EDIT_PAYMENT_METHODS		    		= 				'/admin/update/user/payment/method'
export const EP_DISABLE_TRADING_ACCOUNT		    		= 				'/admin/disable/trading/account'
export const EP_DELETE_TRADING_ACCOUNT		    		= 				'/admin/delete/trading/account'
export const EP_DISABLE_PAYMET_METHOD		    		= 				'/admin/disable/user/payment/method'
export const EP_GET_USER_SETTINGS		    		    = 				'/admin/get/settingvalue'
export const EP_ADD_CLIENT_SETTING		    		    = 				'/admin/add/clientsetting'
export const EP_GET_CLIENT_SETTING		    		    = 				'/admin/get/clientsetting'
export const EP_UPDATE_CLIENT_SETTING		    		= 				'/admin/update/clientsetting'
export const EP_GET_CLIENT_LOGIN_TOKEN 					= 				'/get/user/token'
export const EP_GET_IB_LOGIN_TOKEN 					    = 				'/get/user/token'

export const EP_UPDATE_WITHDRAWAL_COMMENT			     = 				 '/admin/update/withdrawal/trading/comment'
export const EP_UPDATE_DEPOSIT_COMMENT			         = 				 '/admin/update/deposit/comment'
export const EP_GET_ADMIN_DEPOSIT_METHODS			     = 				 '/admin/get/deposit/methods'
export const EP_ADMIN_CHANGE_DEPOSIT_METHOD			    = 				 '/admin/change/deposit/method'

export const EP_CLICK_2_CALL                            =               '/admin/click2call'
export const EP_CLICK_2_ENDCALL                         =               '/admin/click2endcall'


// WEBPACK FOOTER //
// ./src/store/api/endpoints.js